<div class="global-filter">
    <div class="standard-filters">
        <div class="filter districts">
            <h5>Districts:</h5>
            <kendo-multiselect id="districts"
                               [data]="districts"
                               placeholder="-- Any District --"
                               [valueField]="'name'"
                               [valuePrimitive]="true"
                               [textField]="'label'"
                               [popupSettings]="{appendTo:'component'}"
                               (valueChange)="onSettingChange('districts')"
                               [(ngModel)]="selectedDistricts"
                               [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }">
            </kendo-multiselect>
        </div>
        <div class="filter counties">
            <h5>Counties:</h5>
            <kendo-multiselect id="counties"
                               [data]="counties"
                               placeholder="-- Any County --"
                               [valueField]="'name'"
                               [valuePrimitive]="true"
                               [textField]="'label'"
                               [popupSettings]="{appendTo:'component'}"
                               (valueChange)="onSettingChange('counties')"
                               [(ngModel)]="selectedCounties"
                               [kendoDropDownFilter]="{ caseSensitive: false, operator: 'contains' }">
            </kendo-multiselect>
        </div>
        <button *ngIf="defaults && defaults.length" (click)="useDefaults()" class="btn">Use Defaults</button>
    </div>
    <div class="map-filters" *ngIf="extraQueryConfigurations && extraQueryConfigurations.length">
        <div *ngFor="let config of extraQueryConfigurations; index as i;">
            <ng-container *ngIf="!config.duplicateType">
                <div *ngIf="config.type === 'CYFY'">
                    <!-- CYFY -->
                    <fieldset class="radio-group">
                        <legend class="radio-group-title">{{ config.label || 'Year Type' }}:</legend>
                        <input class="radio-group-input" type="radio" [id]="'fy_' + i" [name]="'cyfy_' + i" value="fy" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'fy_' + i">Fiscal</label>
                        <input class="radio-group-input" type="radio" [id]="'cy_' + i" [name]="'cyfy_' + i" value="cy" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'cy_' + i">Calendar</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'SEALCOAT'">
                    <!-- Sealcoat SEALCOAT -->
                    <fieldset class="radio-group">
                        <legend class="radio-group-title">{{ config.label || 'Seal Coat' }}:</legend>
                        <input class="radio-group-input" type="radio" [id]="'include_' + i" [name]="'sealcoat_' + i" value="true" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'include_' + i">Include</label>
                        <input class="radio-group-input" type="radio" [id]="'exclude_' + i" [name]="'sealcoat_' + i" value="false" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'exclude_' + i">Exclude</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'COMPLETED_VS_SAP'">
                    <!-- Completed vs SAP COMPLETED_VS_SAP -->
                    <fieldset class="radio-group">
                        <legend class="radio-group-title">{{ config.label || 'SAP Planned Layers' }}:</legend>
                        <label><input type="checkbox" [checked]="config.value === 'F'" (change)="config.value = $event.currentTarget.checked ? 'F' : 'REMOVE'">Remaining Only (Excludes NOCO)</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'NOCO_VS_PAYROLL'">
                    <!-- NOCO vs Payroll NOCO_VS_PAYROLL -->
                    <fieldset class="fieldset-checkbox">
                        <legend class="radio-group-title">
                            {{ config.label || 'SAP Completed Layers' }}:<br>
                            <span class="text-light font-size--3">(Default: Payroll Actuals)</span>
                        </legend>
                        <label><input type="checkbox" [checked]="config.value === 'T'" (change)="config.value = $event.currentTarget.checked ? 'T' : 'F'">Completed NOCO Only</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'SAP_CALENDAR_YEAR'">
                    <!-- SAP Calendar Year SAP_CALENDAR_YEAR -->
                    <label>
                        Calendar Year:
                        <select class="modifier-class" [(ngModel)]="config.value">
                            <option *ngFor="let year of sapCalendarYears" [ngValue]="year">{{ year }}</option>
                        </select>
                    </label>
                </div>
                <div *ngIf="config.type === 'YEAR'">
                    <!-- Year YEAR -->
                    <label>
                        Operator:
                        <select class="modifier-class" [(ngModel)]="config.value.operator">
                            <option value=""></option>
                            <option value=">" title=">">Greater Than</option>
                            <option value=">=" title=">=">Greater Than or Equal To</option>
                            <option value="=" title="=">Equal To</option>
                            <option value="<=" title="<=">Less Than or Equal To</option>
                            <option value="<" title="<">Less Than</option>
                        </select>
                    </label>
                    <label>
                        Year:
                        <input type="number" min="2000" [max]="maxYear" step="1" [(ngModel)]="config.value.year">
                    </label>
                    <fieldset class="radio-group" *ngIf="config.showYearType">
                        <input class="radio-group-input" type="radio" [id]="'yearfy_' + i" [name]="'year_' + i" value="fy" [(ngModel)]="config.value.yearType" />
                        <label class="radio-group-label" [for]="'yearfy_' + i">Fiscal</label>
                        <input class="radio-group-input" type="radio" [id]="'yearcy_' + i" [name]="'year_' + i" value="cy" [(ngModel)]="config.value.yearType" />
                        <label class="radio-group-label" [for]="'yearcy_' + i">Calendar</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'DATERANGE'">
                    <!-- Date Range DATERANGE -->
                    <label>
                        From:
                        <input type="date" [(ngModel)]="config.value.from" [max]="config.value.to">
                    </label>
                    <label>
                        To:
                        <input type="date" [(ngModel)]="config.value.to" [min]="config.value.from">
                    </label>
                </div>
                <div *ngIf="config.type === 'CRASHFLAG'">
                    <!-- Crash Flag CRASHFLAG -->
                    <label class="inline-block" style="max-width: 40%;">
                        Accident Types:
                        <kendo-multiselect [data]="crashAccidentTypeFlagsSelections"
                                           [popupSettings]="{appendTo:'component'}"
                                           [(ngModel)]="config.value.accidentTypes"
                                           [textField]="'name'"
                                           [valueField]="'value'"
                                           [valuePrimitive]="true">
                        </kendo-multiselect>
                    </label>
                    <strong class="inline-block" style="padding: 0 10px;">WHERE</strong>
                    <label class="inline-block" style="max-width: 40%;">
                        Accident Causes:
                        <kendo-multiselect [data]="crashAccidentCauseFlagsSelections"
                                           [popupSettings]="{appendTo:'component'}"
                                           [(ngModel)]="config.value.accidentCauses"
                                           [textField]="'name'"
                                           [valueField]="'value'"
                                           [valuePrimitive]="true">
                        </kendo-multiselect>
                    </label>
                </div>
                <div *ngIf="config.type === 'BOOLEAN'">
                    <!-- Boolean BOOLEAN -->
                    <fieldset class="radio-group">
                        <legend class="radio-group-title">{{ config.label || 'True/False' }}:</legend>
                        <input class="radio-group-input" type="radio" [id]="'true_' + i" [name]="'bool_' + i" value="true" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'true_' + i">True</label>
                        <input class="radio-group-input" type="radio" [id]="'true_' + i" [name]="'bool_' + i" value="false" [(ngModel)]="config.value" />
                        <label class="radio-group-label" [for]="'true_' + i">False</label>
                    </fieldset>
                </div>
                <div *ngIf="config.type === 'CURRENT_PREDICTED' || config.type === 'PROJECTED'">
                    <!-- Current Predicted CURRENT_PREDICTED -->
                    <!--<fieldset class="radio-group">
                <legend class="radio-group-title">{{ config.label || 'Current Predicted' }}:</legend>
                <input class="radio-group-input" type="radio" [id]="'both_' + i" [name]="'currPred' + i" value="both" [(ngModel)]="config.value.which" />
                <label class="radio-group-label" [for]="'both_' + i">Both</label>
                <input class="radio-group-input" type="radio" [id]="'current_' + i" [name]="'currPred' + i" value="current" [(ngModel)]="config.value.which" />
                <label class="radio-group-label" [for]="'current_' + i">Current</label>
                <input class="radio-group-input" type="radio" [id]="'predicted_' + i" [name]="'currPred' + i" value="predicted" [(ngModel)]="config.value.which" />
                <label class="radio-group-label" [for]="'predicted_' + i">Predicted</label>
        </fieldset>-->
                    <label class="radio-group">
                        Projected Year:
                        <input type="number" [(ngModel)]="config.value.projectedYear" min="1800" max="3000" style="max-width: 70px;">
                    </label>
                </div>
                <div *ngIf="config.type === 'DEPENDENT_FIELDS'">
                    <!-- Dependent Fields DEPENDENT_FIELDS -->
                    <label style="max-width: 60%;">
                        {{ config.primaryColLabel || 'Primary Column' }}:
                        <kendo-multiselect [data]="config.options"
                                           [popupSettings]="{appendTo:'component'}"
                                           [(ngModel)]="config.value.primary">
                        </kendo-multiselect>
                    </label>
                    <label style="max-width: 60%;">
                        {{ config.dependentColLabel || 'Dependant Column' }}:
                        <kendo-multiselect [data]="config.dependentOptions"
                                           [popupSettings]="{appendTo:'component'}"
                                           [(ngModel)]="config.value.dependant">
                        </kendo-multiselect>
                    </label>
                </div>
                <div *ngIf="config.type === 'GENERIC' || config.type === 'CONDITION' || config.type === 'CALCULATED_COLUMN_REPLACEMENT'" class="generic-input">
                    <label style="max-width: 60%;">
                        {{ config.title || config.label || 'Additional Filter' }}:
                        <kendo-multiselect [data]="config.options"
                                           [popupSettings]="{appendTo:'component'}"
                                           [(ngModel)]="config.value"
                                           [textField]="'label'"
                                           [valueField]="'id'"
                                           [valuePrimitive]="true">
                        </kendo-multiselect>
                    </label>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="extra-filters">
        <slot></slot>
    </div>
    <div class="btn-bar">
        <label class="toggle-switch">
            <span class="togggle-switch-label">Zoom on Apply</span>
            <input type="checkbox" name="zoom" class="toggle-switch-input" [(ngModel)]="zoomOnApply">
            <span class="toggle-switch-track"></span>
        </label>
        <button (click)="apply()" class="btn apply" [disabled]="loading" [ngClass]="{ 'loading icon-ui-loading-indicator': loading }">Apply</button>
        <button (click)="cancel()" class="btn">Cancel</button>
    </div>
</div>
